import clsx from 'clsx';

type IProps = {
  onClick?: () => void | Promise<void>;
  children: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  loading: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
};

function PrimaryButton(props: IProps) {
  const classNames = clsx(props.className || 'primary-btn', {
    loading: true,
  });
  const handleClick = async () => {
    if (props.onClick) {
      await props.onClick();
    }
  };

  return (
    <button
      type={props.type || 'button'}
      className={classNames}
      onClick={handleClick}
      disabled={props.disabled || props.loading}
      style={props.style}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
        }}
      >
        {props.loading && (
          <div className="btn-loader">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
        )}
        {props.loading ? <span className="btn-text">Processing...</span> : props.children}
      </div>
    </button>
  );
}

export default PrimaryButton;
